import * as React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  useTranslate,
  useRecordContext,
  required,
  AutocompleteInput,
  useDataProvider,
} from 'react-admin';
import HTMLEditorInput, { validHtml } from "../../common/inputs/HTMLEditorInput";
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import SlugInput from '../../common/inputs/SlugInput';
import YouTubeInput from '../../common/YoutubeInput';
import { CategoryRender } from './DemoVideoCreate';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

export const getYouTubeEmbedCode = (data: any): string => {
  const url = `https://www.youtube.com/embed/${data.videoUrl}`;
  const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v=|v\/|.+\?v=)|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  const code = match ? match[1] : '';
  return data.Thumbnail || `https://i.ytimg.com/vi/${code}/hq720.jpg`;
};
const DemoVideoEdit = () => {
  const { isUpdatable } = useIsPermission("DEMO_VIDEOS");
  const dataProvider = useDataProvider();
  const [categories, setCategories] = React.useState([]) as any;

  React.useEffect(() => {
    dataProvider
      .getList('demo-video-categories', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'name', order: 'ASC' },
        filter: {},
      })
      .then(({ data }) => setCategories(data))
      .catch((error) => console.error(error));
  }, [dataProvider]);
  return <PermissionGuard permission={isUpdatable}>
    <Edit
      transform={(data: any) => ({
        ...data,
        Thumbnail: getYouTubeEmbedCode(data),
        videoUrl: `https://www.youtube.com/embed/${data.videoUrl}`,
        VideoId: null
      })}
      mutationMode={'pessimistic'} title={<DemoVideoTitle />}
      redirect={() => {
        return `demo-videos`
      }}
      resource={'demo-videos'} >
      <SimpleForm
      >
        <TextInput source="title" fullWidth validate={[required(), validateNotEmpty]} />
        <SlugInput source="slug" fullWidth validate={[required(), validateNotEmpty]} />
        <YouTubeInput source="videoUrl" />
        <HTMLEditorInput source={'description'} fullWidth validate={[required(), validHtml]} />
        <AutocompleteInput
          source="demoVideoCategoryId"
          choices={categories}
          optionText={CategoryRender}
          fullWidth
          isRequired
          disabled
        />
      </SimpleForm>
    </Edit>
  </PermissionGuard>
};

const DemoVideoTitle = () => {
  const record = useRecordContext<any>();
  const translate = useTranslate();
  return record ? (
    <span>
      {translate('resources.demo_videos.name', { smart_count: 1 })} &quot;
      {record.title}&quot;
    </span>
  ) : null;
};

export default DemoVideoEdit;
